import { render, staticRenderFns } from "./control-header.vue?vue&type=template&id=12e872ac"
import script from "./control-header.vue?vue&type=script&lang=js"
export * from "./control-header.vue?vue&type=script&lang=js"
import style0 from "./control-header.vue?vue&type=style&index=0&id=12e872ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports